import React from 'react';
import {connect} from 'react-redux';
import {useHistory} from 'react-router-dom';

import './AboutPage.less';

import {Layout} from 'new-components/layout/Layout';
import {BackButton} from "elements/back-button/BackButton";
import {ContactInfo} from "compositions/contact-info/ContactInfo";
import {RestaurantMap} from "compositions/restaurant-map/RestaurantMap";
import {RestaurantGeneralInfo} from "compositions/restaurant-general-info/RestaurantGeneralInfo";
import {RestaurantSchedule} from "compositions/restaurant-schedule/RestaurantSchedule";
import {Card} from "elements/card/Card.tsx";
import {Block} from "compositions/block/Block.tsx";
import {getCurrentRestaurantSelector, getTranslationsSelector} from "../../../selectors";
import {DialogStack} from "dialog-layout/dialog-stack/DialogStack";
import {Offline} from "new-components/popups/offline/Offline";
import {DialogManager} from "dialog-layout/dialog-manager/DialogManager";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {TranslationsContext} from "contexts/translations-context";

const AboutPage = ({currentRestaurant, connectivity, translations}) => {

	const history = useHistory();

	if (!currentRestaurant) {
		return <Layout>
			Restaurant not found
		</Layout>
	}


	return (
		<TranslationsContext.Provider value={translations}>
			<Layout>
				<div className="about-page">
					<div className="about-page__back-button">
						<BackButton onClick={() => history.goBack()}/>
					</div>
					<header className="about-page__general-info">
						<RestaurantGeneralInfo
							title={currentRestaurant.name}
							description={currentRestaurant.infoPage}
						/>
					</header>
					<main className="about-page__schedule">
						<Block title={getSafeTranslation('AboutPage.openingHoursBlockTitle', translations)}>
							<Card isNoPaddings>
								<RestaurantSchedule
									scheduleDaily={currentRestaurant.scheduleDaily}
									deliveryType={currentRestaurant.deliveryType}
								/>
							</Card>
						</Block>
					</main>
					{
						!!currentRestaurant.latitude && !!currentRestaurant.longitude && (<aside className="about-page__location">
							<Block title={getSafeTranslation('AboutPage.locationBlockTitle', translations)}>
								<RestaurantMap
									latitude={currentRestaurant.latitude}
									longitude={currentRestaurant.longitude}
									address={currentRestaurant.address}
									zip={currentRestaurant.zipCode}
								/>
							</Block>
						</aside>)
					}

					{
						(currentRestaurant.phone || currentRestaurant.address) && (
							<aside className="about-page__contact">
								<Block title={getSafeTranslation('AboutPage.contactInfoBlockTitle', translations)}>
									<ContactInfo
										phone={currentRestaurant.phone}
										latitude={currentRestaurant.latitude}
										longitude={currentRestaurant.longitude}
										address={currentRestaurant.address}
										zip={currentRestaurant.zipCode}
										contactUsText={currentRestaurant.contactUsText}
									/>
								</Block>
							</aside>
						)
					}
					<DialogManager>
						<DialogStack>
							{
								connectivity.isOnline === false && <Offline
								/>
							}
						</DialogStack>
					</DialogManager>
				</div>
			</Layout>
		</TranslationsContext.Provider>
	);
};

const mapStateToProps = state => {
	return {
		currentRestaurant: getCurrentRestaurantSelector(state),
		connectivity: state.connectivity,
		translations: getTranslationsSelector(state),
	}
}

const mapDispatchToProps = dispatch => {
	return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AboutPage);
